export var ScrollOptions = {
    suppressScrollX: true,
    wheelPropagation: true,
    wheelSpeed: 1,
};



//////////////////
// WEBPACK FOOTER
// ./src/constants/ScrollOptions.ts
// module id = 79
// module chunks = 3